import { useCallback, useState } from 'react';

import { HorizontalScroll } from '@ui/components/HorizontalScroll';
import { useMediaQuery } from '@providers/MediaQueryProvider';
import { PageSubTitle } from '@ui/components/PageSubTitle';

import { PromotedClub } from '@features/club/ui/PromotedClubs/PromotedClub';
import { StartYourOwnClubBanner } from '@features/club/ui/PromotedClubs/StartYourOwnClubBanner';
import { components } from '@features/shared/api/public';

import styles from './PromotedClubs.module.css';

type Props = {
  clubs?: components['schemas']['ClubPublicDto'][];
  isMemberClubIds: string[];
};
export function PromotedClubs({ clubs, isMemberClubIds }: Props) {
  const isMobile = useMediaQuery() === 'mobile';
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = useCallback(() => setIsModalOpen(true), [setIsModalOpen]);
  const closeModal = useCallback(() => setIsModalOpen(false), [setIsModalOpen]);

  if (!clubs) return null;

  return (
    <>
      {!isMobile && <PageSubTitle variant="new">Популярные клубы</PageSubTitle>}

      <HorizontalScroll className={styles.promotedClubs}>
        {clubs.map((club) => (
          <PromotedClub
            key={club.clubId}
            club={club}
            isMember={!!isMemberClubIds.find((id) => id === club.clubId)}
          />
        ))}

        <StartYourOwnClubBanner
          className={styles.inlineBanner}
          isModalOpen={isModalOpen}
          openModal={openModal}
          closeModal={closeModal}
        />
      </HorizontalScroll>

      <div className={styles.separateRowBannerWrapper}>
        <StartYourOwnClubBanner
          isModalOpen={isModalOpen}
          openModal={openModal}
          closeModal={closeModal}
        />
      </div>
    </>
  );
}
